export const ODOMETER_MIN = 0;
export const ODOMETER_MAX = 9999999.9;

export const DUTY_STATUS_ERRORS = {
  LOCATION: 'Enter a valid Location field.',
  NOTES: 'Enter a valid Note field.',
  INTERVAL: 'Your date interval is not valid as it may intersect with other events',
  START_TIME: 'Starting time must come before the end time',
  ORIGIN_START_TIME: 'Ending time must come after the original start time of the selected status',
  ORIGIN_END_TIME: 'Starting time must come before the original end time of the selected status',
  OVERWRITTEN_DRIVE_TIME: 'Automatically recorded drive time cannot be overwritten',
  ODOMETER_BOUNDS: `Odometer must be between ${ODOMETER_MIN} and ${Math.floor(
    ODOMETER_MAX,
  ).toLocaleString('en-US')}`,
  CANNOT_EDIT_ODOMETER: 'Cannot Edit Odometer',
  CANNOT_EDIT_LOCATION: 'Cannot Edit Location',
  ODOMETER_WARNING:
    'The ELD Mandate requires the automatic recording of odometer readings from the engine’s computer. Odometer readings can only be edited if they were not automatically recorded.',
  LOCATION_WARNING:
    'The ELD Mandate requires the automatic recording of GPS location as the distance to the nearest town of 5,000 or more. Locations can only be entered by drivers if Maven cannot automatically determine location.',
};

export const TIME_INPUT_TYPE = {
  START_TIME: 'startTime',
  END_TIME: 'endTime',
};
